import { Box } from '@mui/material';
import RofDataTables from './RofDataTables';
import RofDataMonitoring from './RofDataMonitoring';
import RofReports from './RofReports';
import ProjectInfo from '../shared-components/ProjectInfo';

/**
 * Wraps the Flame Cap Kiln components that render under 'Project Info' || 'Data Monitoring' || 'Data Tables' || 'Reports'
 * @param {Object} props 
 * @param {'Flame Cap Kiln' | 'Conservation Burns'} props.burnType
 * @param {string | null} props.selectedCategory 'Project Info' || 'Data Monitoring' || 'Data Tables' || 'Reports'
 * @returns {JSX.Element} Associated component for the selected button
 */
export default function RofDataSelection({ selectedCategory, burnType }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {
                selectedCategory === 'Project Info' &&
                <ProjectInfo burnType={burnType} />
            }
            {
                selectedCategory === 'Data Monitoring' &&
                <RofDataMonitoring />
            }
            {
                selectedCategory === 'Data Tables' &&
                <RofDataTables />
            }
            {
                selectedCategory === 'Reports' &&
                <RofReports />
            }
        </Box>
    )
}
